module.exports = "<app-all-menus></app-all-menus>\n"


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/lr-number/lr-number.component.html
// module id = ../../../../../src/app/lr-number/lr-number.component.html
// module chunks = main